export default class AnimationVariants {
    static heightScaleDownFade = {
        visible: {
            opacity: 1,
            height:  "auto",
            y:       0
        },
        hidden:  {
            opacity: 0,
            height:  0,
            y:       '-10%'
        }
    };

    static heightScaleUpFade = {
        visible: {
            opacity: 1,
            height:  "auto",
            y:       0
        },
        hidden:  {
            opacity: 0,
            height:  0,
            y:       '10%'
        }
    };

    static scaleUpFade = {
        visible: {
            opacity: 1,
            y:       0
        },
        hidden:  {
            opacity: 0,
            y:       '10%'
        }
    };
}
